var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "table" }, [
    _c("div", [
      _c("p", {
        staticClass: "icon-jujue closeBtn",
        on: { click: _vm.routerBack },
      }),
    ]),
    _c(
      "div",
      { staticClass: "container" },
      [
        _c(
          "el-row",
          { staticClass: "action-btn-row" },
          [
            _c(
              "el-button",
              {
                directives: [
                  {
                    name: "acl",
                    rawName: "v-acl",
                    value: _vm.QSPI_QBR_EXPORT_HIST_PERF,
                    expression: "QSPI_QBR_EXPORT_HIST_PERF",
                  },
                ],
                staticClass: "btn",
                attrs: { size: "mini", type: "primary" },
                on: { click: _vm.onExport },
              },
              [_vm._v("导出")]
            ),
          ],
          1
        ),
        _c(
          "el-table",
          {
            ref: "fpaPcnList",
            attrs: {
              data: _vm.tableData,
              "span-method": _vm.objectSpanMethod1,
              "max-height": "760",
              border: "",
              "highlight-current-row": "",
              "show-overflow": "ellipsis",
            },
          },
          [
            _c("el-table-column", {
              attrs: {
                prop: "measurements",
                label: "Measurements",
                width: "210",
              },
            }),
            _c("el-table-column", {
              attrs: { prop: "yearProduct", label: "Year或产品", width: "100" },
            }),
            _vm._l(_vm.groupList[0].facilityList, function (item, index) {
              return _c(
                "el-table-column",
                {
                  key: index,
                  attrs: {
                    align: "center",
                    label: item.facilityName,
                    "show-overflow-tooltip": "",
                    "min-width": "120",
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            scope.row.measurements ===
                            "Feedback\n（绝对量+投诉率）"
                              ? _c(
                                  "div",
                                  _vm._l(
                                    scope.row.facilityDataList[index]
                                      .dataDetailList,
                                    function (v, i) {
                                      return _c("span", { key: i }, [
                                        _c(
                                          "span",
                                          {
                                            class: {
                                              orangeClass:
                                                v.attrOneColor === "orange",
                                              greenClass:
                                                v.attrOneColor === "green",
                                              redClass:
                                                v.attrOneColor === "red",
                                              blackClass: !v.attrOneColor,
                                            },
                                          },
                                          [_vm._v(_vm._s(v.attrOne) + " ")]
                                        ),
                                      ])
                                    }
                                  ),
                                  0
                                )
                              : _vm._e(),
                            scope.row.measurements === "QIP"
                              ? _c(
                                  "div",
                                  _vm._l(
                                    scope.row.facilityDataList[index]
                                      .dataDetailList,
                                    function (v, i) {
                                      return _c("span", { key: i }, [
                                        _c(
                                          "span",
                                          {
                                            class: {
                                              orangeClass:
                                                v.attrOneColor === "orange",
                                              greenClass:
                                                v.attrOneColor === "green",
                                              redClass:
                                                v.attrOneColor === "red",
                                              blackClass: !v.attrOneColor,
                                            },
                                          },
                                          [_vm._v(_vm._s(v.attrOne) + " ")]
                                        ),
                                      ])
                                    }
                                  ),
                                  0
                                )
                              : _vm._e(),
                            scope.row.measurements === "MSV"
                              ? _c(
                                  "div",
                                  _vm._l(
                                    scope.row.facilityDataList[index]
                                      .dataDetailList,
                                    function (v, i) {
                                      return _c("div", { key: i }, [
                                        _c(
                                          "p",
                                          {
                                            class: {
                                              redClass:
                                                v.attrOneColor === "red",
                                              greenClass:
                                                v.attrOneColor === "green",
                                              blackClass: !v.attrOneColor,
                                            },
                                          },
                                          [_vm._v(_vm._s(v.attrOne) + " ")]
                                        ),
                                      ])
                                    }
                                  ),
                                  0
                                )
                              : _vm._e(),
                            scope.row.measurements === "sensory"
                              ? _c(
                                  "div",
                                  _vm._l(
                                    scope.row.facilityDataList[index]
                                      .dataDetailList,
                                    function (v, i) {
                                      return _c("div", { key: i }, [
                                        _c(
                                          "p",
                                          [
                                            _c(
                                              "span",
                                              {
                                                class: {
                                                  redClass:
                                                    v.attrOneColor === "red",
                                                  greenClass:
                                                    v.attrOneColor === "green",
                                                  blackClass: !v.attrOneColor,
                                                },
                                              },
                                              [_vm._v(_vm._s(v.attrOne))]
                                            ),
                                            _vm._v("   "),
                                            _vm._l(
                                              v.attrTwo.split(" "),
                                              function (ele, idx) {
                                                return _c(
                                                  "span",
                                                  {
                                                    key: idx,
                                                    class:
                                                      Number(ele) < 70
                                                        ? "redClass"
                                                        : "blackClass",
                                                  },
                                                  [_vm._v(_vm._s(ele) + " ")]
                                                )
                                              }
                                            ),
                                          ],
                                          2
                                        ),
                                      ])
                                    }
                                  ),
                                  0
                                )
                              : _vm._e(),
                            scope.row.measurements === "SQMS"
                              ? _c(
                                  "div",
                                  _vm._l(
                                    scope.row.facilityDataList[index]
                                      .dataDetailList,
                                    function (v, i) {
                                      return _c("span", { key: i }, [
                                        _c(
                                          "span",
                                          {
                                            class: {
                                              redClass:
                                                v.attrOneColor === "red",
                                              greenClass:
                                                v.attrOneColor === "green",
                                              blackClass: !v.attrOneColor,
                                            },
                                          },
                                          [_vm._v(_vm._s(v.attrOne) + " ")]
                                        ),
                                      ])
                                    }
                                  ),
                                  0
                                )
                              : _vm._e(),
                            scope.row.measurements === "AAA"
                              ? _c(
                                  "div",
                                  _vm._l(
                                    scope.row.facilityDataList[index]
                                      .dataDetailList,
                                    function (v, i) {
                                      return _c("span", { key: i }, [
                                        _c("p", [
                                          _c(
                                            "span",
                                            {
                                              class: {
                                                redClass:
                                                  v.attrOneColor === "red",
                                                greenClass:
                                                  v.attrOneColor === "green",
                                                blackClass: !v.attrOneColor,
                                              },
                                            },
                                            [_vm._v(_vm._s(v.attrOne))]
                                          ),
                                          _vm._v("   "),
                                          _c(
                                            "span",
                                            {
                                              class: {
                                                redClass:
                                                  v.attrTwoColor === "red",
                                                greenClass:
                                                  v.attrTwoColor === "green",
                                                blackClass: !v.attrTwoColor,
                                              },
                                            },
                                            [_vm._v(_vm._s(v.attrTwo))]
                                          ),
                                          _vm._v("   "),
                                          _c(
                                            "span",
                                            {
                                              class: {
                                                redClass:
                                                  v.attrThreeColor === "red",
                                                greenClass:
                                                  v.attrThreeColor === "green",
                                                blackClass: !v.attrThreeColor,
                                              },
                                            },
                                            [_vm._v(_vm._s(v.attrThree))]
                                          ),
                                        ]),
                                      ])
                                    }
                                  ),
                                  0
                                )
                              : _vm._e(),
                            scope.row.measurements ===
                              "previous QBR results & comments" && _vm.isRoles
                              ? _c(
                                  "div",
                                  _vm._l(
                                    scope.row.prePerformDataDetailList[0]
                                      .performanceValueList,
                                    function (v, i) {
                                      return _c(
                                        "div",
                                        {
                                          key: i,
                                          staticStyle: { "text-align": "left" },
                                        },
                                        [
                                          _c("p", [
                                            _vm._v(_vm._s(v.split("\n")[0])),
                                          ]),
                                          _c("p", [
                                            _vm._v(_vm._s(v.split("\n")[1])),
                                          ]),
                                          _c("p", [
                                            _vm._v(_vm._s(v.split("\n")[2])),
                                          ]),
                                          _c("p", [
                                            _vm._v(_vm._s(v.split("\n")[3])),
                                          ]),
                                          _c("p", [
                                            _vm._v(_vm._s(v.split("\n")[4])),
                                          ]),
                                          _c("p", [
                                            _vm._v(_vm._s(v.split("\n")[5])),
                                          ]),
                                        ]
                                      )
                                    }
                                  ),
                                  0
                                )
                              : _vm._e(),
                          ]
                        },
                      },
                    ],
                    null,
                    true
                  ),
                },
                [
                  _c("template", { slot: "header" }, [
                    _c("p", [_vm._v(_vm._s(item.facilityName))]),
                  ]),
                ],
                2
              )
            }),
          ],
          2
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }